import React, { useState } from "react";
import API from "./config/api";
import { useAuth } from "./context/AuthContext";

export default function LoginPage() {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const { login: authLogin } = useAuth();
  
const login = async () => {

  try {
const response = await fetch(
  `${API}/auth/login`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          username,
          password
        })
      }
    );

    const data = await response.json();

    if (!response.ok) {
      setMsg(data.detail || "Login failed");
      return;
    }

    localStorage.setItem(
      "FENTASAFE_TOKEN",
      data.access_token
    );

    const meResponse = await fetch(
      `${API}/auth/me`,
      {
        headers: {
          Authorization: `Bearer ${data.access_token}`
        }
      }
    );

    const user = await meResponse.json();

    authLogin(user);

    setMsg(
      `Login successful (${user.role})`
    );

    console.log("Logged in user:", user);

  } catch (err) {

    console.error(err);

    setMsg("Unable to connect");

  }
};
  return (
    <div style={{ padding: 40 }}>
      <h2>FentaSafe Customer Login</h2>

      <input
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />

      <br /><br />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <br /><br />

      <button onClick={login}>
        Login
      </button>

      <p>{msg}</p>

    </div>
  );
}